import { apiClient } from './apiClient';

export const mvpTableService = {
  // MVP-Tabellen abrufen
  getMVPTable: async () => {
    try {
      const response = await apiClient.get('/results/mvp/table');
      // apiClient gibt direkt data zurück, wenn vorhanden
      return response;
    } catch (error) {
      console.error('Fehler beim Laden der MVP-Tabellen:', error);
      // Bei Fehler: leeres Objekt zurückgeben statt Error zu werfen
      return {};
    }
  }
}; 